<div
    class="column"
    [class.active]="isActive()"
    [class.active-more-action]="isSettingsMenuOpened()"
    [webSingleHover]="{ threshold: 30, type: 'percent' }"
    (hovered)="hovered($event)"
    cdkDrag
    [cdkDragData]="entity()"
    (cdkDragStarted)="dragStarted()"
    (cdkDragEnded)="dragEnded()"
>
    @if (isSectionFlexibleWidths()) {
        <div class="column-width-label">{{ widthPercent() | number: "1.0-1" }}%</div>
    }

    <div class="custom-dnd-preview" *cdkDragPreview>
        <img src="./assets/img/websites/lpc-column-preview-icon.svg" alt="Column preview" />
    </div>
    <div class="column-placeholder custom-dnd-placeholder" *cdkDragPlaceholder></div>

    <div
        #animatedElem
        class="column-wrapper"
        [id]="entity().id"
        [attr.data-raw-id]="entity().id"
        [style.--column-gap-half]="gapHalf()"
        [style.--column-justify]="justify()"
        [style.--column-shadow]="shadow()"
        [style.--column-opacity]="opacity()"
        [style.--column-radius-tl]="radiusTl()"
        [style.--column-radius-tr]="radiusTr()"
        [style.--column-radius-br]="radiusBr()"
        [style.--column-radius-bl]="radiusBl()"
        [style.--column-padding-top]="paddingTop()"
        [style.--column-padding-right]="paddingRight()"
        [style.--column-padding-bottom]="paddingBottom()"
        [style.--column-padding-left]="paddingLeft()"
        [style.--column-border-top]="borderTop()"
        [style.--column-border-right]="borderRight()"
        [style.--column-border-bottom]="borderBottom()"
        [style.--column-border-left]="borderLeft()"
        [style.--column-bg]="bg()"
        [style.--column-bg-position]="bgPosition()"
        [style.--column-bg-repeat]="bgRepeat()"
        [style.--column-bg-size]="bgSize()"
        [style.--column-bg-filter]="bgFilter()"
        [style.--column-bg-margin]="bgMargin()"
        [style.--column-radius-tl-mobile]="radiusTlMobile()"
        [style.--column-radius-tr-mobile]="radiusTrMobile()"
        [style.--column-radius-br-mobile]="radiusBrMobile()"
        [style.--column-radius-bl-mobile]="radiusBlMobile()"
        [style.--column-padding-top-mobile]="paddingTopMobile()"
        [style.--column-padding-right-mobile]="paddingRightMobile()"
        [style.--column-padding-bottom-mobile]="paddingBottomMobile()"
        [style.--column-padding-left-mobile]="paddingLeftMobile()"
        [style.--column-border-top-mobile]="borderTopMobile()"
        [style.--column-border-right-mobile]="borderRightMobile()"
        [style.--column-border-bottom-mobile]="borderBottomMobile()"
        [style.--column-border-left-mobile]="borderLeftMobile()"
        [style.--column-bg-mobile]="bgMobile()"
        [style.--column-bg-position-mobile]="bgPositionMobile()"
        [style.--column-bg-repeat-mobile]="bgRepeatMobile()"
        [style.--column-bg-size-mobile]="bgSizeMobile()"
        [style.--column-bg-filter-mobile]="bgFilterMobile()"
        [style.--column-bg-margin-mobile]="bgMarginMobile()"
        [style.--column-radius-tl-tablet]="radiusTlTablet()"
        [style.--column-radius-tr-tablet]="radiusTrTablet()"
        [style.--column-radius-br-tablet]="radiusBrTablet()"
        [style.--column-radius-bl-tablet]="radiusBlTablet()"
        [style.--column-padding-top-tablet]="paddingTopTablet()"
        [style.--column-padding-right-tablet]="paddingRightTablet()"
        [style.--column-padding-bottom-tablet]="paddingBottomTablet()"
        [style.--column-padding-left-tablet]="paddingLeftTablet()"
        [style.--column-border-top-tablet]="borderTopTablet()"
        [style.--column-border-right-tablet]="borderRightTablet()"
        [style.--column-border-bottom-tablet]="borderBottomTablet()"
        [style.--column-border-left-tablet]="borderLeftTablet()"
        [style.--column-bg-tablet]="bgTablet()"
        [style.--column-bg-position-tablet]="bgPositionTablet()"
        [style.--column-bg-repeat-tablet]="bgRepeatTablet()"
        [style.--column-bg-size-tablet]="bgSizeTablet()"
        [style.--column-bg-filter-tablet]="bgFilterTablet()"
        [style.--column-bg-margin-tablet]="bgMarginTablet()"
    >
        <div class="column-inner">
            <div class="column-widgets-list">
                <div
                    [id]="entity().id"
                    cdkDropList
                    [cdkDropListAutoScrollStep]="25"
                    [cdkDropListData]="entity().children"
                    [cdkDropListConnectedTo]="connectedTo()"
                    [cdkDropListEnterPredicate]="enterPredicate"
                    (cdkDropListDropped)="dropWidget($event)"
                >
                    @for (widget of widgets(); track widget.id; let i = $index) {
                        @if (isEntityWidget(widget)) {
                            <web-widget
                                [index]="i"
                                [widget]="widget"
                                [column]="entity()"
                                [blockId]="blockId()"
                                [widgetErrors]="widgetErrorsById(widget.id)"
                                [isMobile]="isMobile()"
                                [isTablet]="isTablet()"
                            />
                        }

                        @if (isEntityGrid(widget)) {
                            <web-grid [index]="i" [grid]="widget" [column]="entity()" [blockId]="blockId()" />
                        }

                        @if (isEntityTab(widget)) {
                            <web-default-tab [entity]="widget" />
                        }
                    } @empty {
                        <div class="widget-empty-state" (click)="addWidget()">
                            <div>
                                <div class="add-icon">
                                    <span class="sp-icon icon-plus-add"> </span>
                                </div>
                                <p>
                                    {{ "control_add_new_widget" | translate }}
                                </p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="column-bg"></div>
    </div>

    @if (hideControls()) {
        @if (hoverState()?.hover || isActive() || isSettingsMenuOpened()) {
            <web-default-column-controls
                class="column-controls"
                [disableCopyEvent]="disableColumnCopy() || isCartWidgetInside() || isColumnRestricted()"
                [disableRemoveEvent]="disableColumnRemove() || isCartWidgetInside() || isColumnRestricted()"
                [selectActionTooltip]="'control_column_settings' | translate"
                [disableRemoveEventTooltip]="isEcommerceMode() ? '' : ('disable_remove_column_hint' | translate)"
                (copyEvent)="copyColumn()"
                (deleteEvent)="removeColumn()"
                (selectEvent)="selectColumn()"
                (toggleMoreActionState)="setSettingsMenuOpened($event)"
            />
            <web-drag-handle class="drag-handle" [cdkDragHandleDisabled]="isColumnRestricted()" cdkDragHandle />
        }
    }
</div>
